import { render, staticRenderFns } from "./appPagination.vue?vue&type=template&id=5ccd65d6"
import script from "./appPagination.vue?vue&type=script&lang=js"
export * from "./appPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports